var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 1V2.33333H5.33333V1H4V2.33333H3.33333C2.59333 2.33333 2.00667 2.93333 2.00667 3.66667L2 13C2 13.7333 2.59333 14.3333 3.33333 14.3333H12.6667C13.4 14.3333 14 13.7333 14 13V3.66667C14 2.93333 13.4 2.33333 12.6667 2.33333H12V1H10.6667ZM12.6667 13H3.33333V5.66667H12.6667V13Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99709 11.2981V12.25H6.87397V11.2981H9.99709ZM7.38803 6.75V12.25H6V6.75H7.38803ZM10 8.9636V9.8853H6.87397V8.9636H10ZM9.99709 6.75V7.7057H6.87397V6.75H9.99709Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/event-icon.3a7cdb09f439074484e39cf1c2c428bc.svg";
export { ForwardRef as ReactComponent };